'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
require('./settings-9ee2f03f.js');
require('./browser-05a2bba8.js');
require('react-dom');
require('./_commonjsHelpers-3fc1f64e.js');
require('./_react_commonjs-external-30e5c7b3.js');
require('./_prop-types_commonjs-external-c51b2bd5.js');
require('lodash/isFunction');
require('./react-lifecycles-compat.es-59afd828.js');
require('./_react-dom_commonjs-external-3c49a59a.js');
require('./index-cd777c24.js');
var modal = require('./modal.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  ", "\n  ", "\n  @media (max-width: 767px) {\n    ", "\n    ", "\n  }\n"], ["\n  ", "\n  ", "\n  @media (max-width: 767px) {\n    ", "\n    ", "\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  width: fit-content;\n  color: ", ";\n  cursor: default;\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  width: fit-content;\n  color: ", ";\n  cursor: default;\n  ", "\n"]);

var Container = styled__default.div(_templateObject, function (props) {
  return props.margin && "margin: " + props.margin;
}, function (props) {
  return props.padding && "padding: " + props.padding;
}, function (props) {
  return props.mPadding && "padding: " + props.mPadding;
}, function (props) {
  return props.mMargin && "margin: " + props.mMargin;
});
var ChildrenContainer = styled__default.div(_templateObject2, function (props) {
  return props.color ? props.color : "#aaa";
}, function (props) {
  return !props.disabled && "\n    cursor: pointer;\n    :hover {\n    color: " + (props.hoverColor ? props.hoverColor : "#333") + ";\n  }\n  ";
});

var WithModal = function WithModal(_ref) {
  var children = _ref.children,
      _ref$modalProps = _ref.modalProps,
      modalProps = _ref$modalProps === undefined ? {} : _ref$modalProps,
      content = _ref.content,
      color = _ref.color,
      hoverColor = _ref.hoverColor,
      disabled = _ref.disabled,
      props = _babelHelpers.objectWithoutProperties(_ref, ["children", "modalProps", "content", "color", "hoverColor", "disabled"]);

  var _useState = React.useState(false),
      _useState2 = _babelHelpers.slicedToArray(_useState, 2),
      isModalOpened = _useState2[0],
      setModalOpen = _useState2[1];

  var handleModalOpen = function handleModalOpen() {
    if (!disabled) {
      setModalOpen(!isModalOpened);
    }
  };

  return React__default.createElement(
    Container,
    props,
    React__default.createElement(
      ChildrenContainer,
      {
        disabled: disabled,
        color: color,
        hoverColor: hoverColor,
        onClick: handleModalOpen },
      children
    ),
    React__default.createElement(
      modal,
      _babelHelpers._extends({
        rootId: "#root",
        isOpen: isModalOpened,
        modalSize: "small",
        onClose: handleModalOpen
      }, modalProps),
      content
    )
  );
};
WithModal.propTypes = {
  /** The margin of the HOC container */
  margin: PropTypes$1.string,
  /** The padding of the HOC container */
  padding: PropTypes$1.string,
  /** The mobile padding of the HOC container */
  mPadding: PropTypes$1.string,
  /** The mobile margin of the HOC container */
  mMargin: PropTypes$1.string,
  /** The element that you want to use the modal */
  children: PropTypes$1.element,
  /** The modal props, you can see more at the modal topic */
  modalProps: PropTypes$1.object,
  /** The content element on modal */
  content: PropTypes$1.element,
  /** Parse the color of the children element */
  color: PropTypes$1.string,
  /** Parse the color of the children element when hover */
  hoverColor: PropTypes$1.string,
  /** Disabled the open modal and you can't use the color and hover color props */
  disabled: PropTypes$1.bool
};
WithModal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WithModal",
  "props": {
    "modalProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "The modal props, you can see more at the modal topic"
    },
    "margin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The margin of the HOC container"
    },
    "padding": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The padding of the HOC container"
    },
    "mPadding": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The mobile padding of the HOC container"
    },
    "mMargin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "The mobile margin of the HOC container"
    },
    "children": {
      "type": {
        "name": "element"
      },
      "required": false,
      "description": "The element that you want to use the modal"
    },
    "content": {
      "type": {
        "name": "element"
      },
      "required": false,
      "description": "The content element on modal"
    },
    "color": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Parse the color of the children element"
    },
    "hoverColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Parse the color of the children element when hover"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Disabled the open modal and you can't use the color and hover color props"
    }
  }
};

exports.WithModal = WithModal;
exports.default = WithModal;
//# sourceMappingURL=with-modal.js.map
